<div id="content" class="extensible meeting-record-shell">
  <ngx-dropzone
    class="meeting-record-dropzone"
    (change)="onShellDropzoneChange($event)"
    [disableClick]="true"
    [maxFileSize]="attachment_max_file_size_bytes"
    [accept]="attachment_accepted_types"
  >
    <div class="page-title sticky">
      <h1>{{ page_title }}</h1>

      <app-pending-changes-save-status
        class="meeting-record-autosave"
        [status_state]="pending_changes_save_status"
        [tooltip]="autosave_tooltip()"
        [show_when_label_empty]="true"
        label_max_width="14rem"
      />

      <button mat-flat-button [routerLink]="back_route" style="margin-left: 1rem">
        <mat-icon>arrow_back</mat-icon>
        Volver
      </button>
      @if (show_manual_save_button()) {
        <button mat-flat-button color="accent" type="button" (click)="forceMeetingRecordSave()" [disabled]="!meetingRecordFormGroup.valid">
          <mat-icon>save</mat-icon>
          Guardar
        </button>
      }
      <button mat-icon-button type="button" [matMenuTriggerFor]="meetingRecordActionsMenu" aria-label="Más acciones">
        <mat-icon>more_vert</mat-icon>
      </button>
      <mat-menu #meetingRecordActionsMenu="matMenu">
        <button mat-menu-item type="button" (click)="forceMeetingRecordSave()">
          <mat-icon>save</mat-icon>
          <span>Forzar guardado</span>
        </button>
        @if (!is_create) {
          <button mat-menu-item type="button" (click)="downloadPdf()">
            <mat-icon>picture_as_pdf</mat-icon>
            <span>Descargar PDF</span>
          </button>
          @if (can_manage_attachments()) {
            <button mat-menu-item type="button" (click)="triggerAttachmentFilePicker(attachmentFileInput)">
              <mat-icon>upload_file</mat-icon>
              <span>Subir archivo</span>
            </button>
          }
        }
      </mat-menu>
      <input
        #attachmentFileInput
        type="file"
        multiple
        hidden
        [accept]="attachment_accepted_types"
        (change)="onAttachmentFileInputChange($event)"
      />
    </div>

    <div class="container">
      <div class="meeting-record-layout" [formGroup]="meetingRecordFormGroup">
        <div class="meeting-record-main-column">
          <section class="card card-block card-full-width meeting-record-title-card">
            <div class="card-header-simple">
              <h2>Datos de la reunión</h2>
            </div>
            <div class="acta-meta-grid">
              <mat-form-field appearance="outline" class="nobottom">
                <mat-label>Título</mat-label>
                <input matInput formControlName="title" />
              </mat-form-field>

              <mat-form-field appearance="outline" class="nobottom meeting-record-date-in-title">
                <mat-label>Fecha de reunión</mat-label>
                <input matInput [matDatepicker]="title_date_picker" formControlName="date" />
                <mat-datepicker-toggle matSuffix [for]="title_date_picker"></mat-datepicker-toggle>
                <mat-datepicker #title_date_picker></mat-datepicker>
              </mat-form-field>
            </div>
          </section>

          <div class="meeting-record-main-content">
            <section class="card card-block card-full-width">
              <div class="card-header-simple">
                <h2>Asistentes</h2>
              </div>

              <mat-form-field appearance="outline" class="nobottom" [floatLabel]="'always'">
                <mat-label>Asistentes</mat-label>
                <mat-chip-grid #chipGrid aria-label="Asistentes">
                  @for (user of meetingRecordFormGroup.value.users; track user?.id ?? $index; let i = $index) {
                    <mat-chip-row (removed)="removeUser(i)">
                      {{ user?.name || '' }} {{ user?.surnames || '' }}
                      <button matChipRemove [attr.aria-label]="'Remove ' + (user?.name || '') + ' ' + (user?.surnames || '')">
                        <mat-icon>cancel</mat-icon>
                      </button>
                    </mat-chip-row>
                  }
                </mat-chip-grid>

                <input
                  #userChipInput
                  #userInputTrigger="matAutocompleteTrigger"
                  placeholder="Buscar usuario..."
                  [matChipInputFor]="chipGrid"
                  [matChipInputSeparatorKeyCodes]="user_chip_separator_keys"
                  (keydown.enter)="onUserChipEnter($event)"
                  [matAutocomplete]="userAuto"
                  [formControl]="userInputValue"
                />

                <mat-autocomplete
                  #userAuto="matAutocomplete"
                  [autoActiveFirstOption]="auto_active_create_user_option"
                  (optionSelected)="selectUser($event)"
                >
                  @if (user_create_typed_name) {
                    <mat-option [value]="create_user_option_value">
                      <mat-icon>add</mat-icon>
                      Crear usuario con más datos
                    </mat-option>
                  }
                  @if (users_searched.length > 0) {
                    <mat-divider></mat-divider>
                  }
                  @for (user of users_searched; track user.id) {
                    <mat-option [value]="user" class="user-option">
                      <div class="user-name">{{ user.name || '' }} {{ user.surnames || '' }}</div>
                      <div class="user-role">
                        {{ user.role.name }}
                      </div>
                    </mat-option>
                  }
                </mat-autocomplete>
              </mat-form-field>
            </section>

            <div class="acta-tab-chips card-full-width" role="tablist" aria-label="Secciones del acta">
              @for (tab of acta_tabs; track tab.id) {
                <button
                  type="button"
                  class="acta-tab-chip"
                  [class.acta-tab-chip-active]="active_acta_tab() === tab.id"
                  role="tab"
                  [attr.aria-selected]="active_acta_tab() === tab.id"
                  (click)="setActiveActaTab(tab.id)"
                >
                  <span class="acta-tab-chip-label">{{ tab.label }}</span>
                  @if (tab.id === 'attachments' && attachments_count() > 0) {
                    <span class="acta-tab-count-badge">{{ attachments_count() }}</span>
                  }
                </button>
              }
            </div>

            <section class="card card-block card-full-width acta-tab-content-section">
              @switch (active_acta_tab()) {
                @case ('acta') {
                  <app-meeting-record-acta-tab
                    [form_group]="meetingRecordFormGroup"
                    [tiny_mce_api_key]="tinyMceApiKey"
                    [tiny_mce_init]="tinyMceInit"
                  />
                }
                @case ('ai_summary') {
                  <app-meeting-record-summary-tab
                    [ai_summary_html]="ai_summary_html()"
                    [meeting_record_id]="meetingRecordId"
                    [media_recordings]="media_recordings()"
                    [can_generate_summary]="!is_create"
                    [summary_generation_status]="summary_generation_status()"
                    (summary_generation_status_change)="onSummaryGenerationStatusChange($event)"
                    (diarization_seek)="jumpToDiarizationAtSeconds($event)"
                  />
                }
                @case ('diarization') {
                  <app-meeting-record-diarization-tab
                    [is_create]="is_create"
                    [media_recordings]="media_recordings()"
                    [seek_seconds]="diarization_seek_seconds()"
                  />
                }
                @case ('personal_notes') {
                  <app-meeting-record-personal-notes-tab
                    [is_create]="is_create"
                    [personal_notes_control]="personal_notes_control"
                    [tiny_mce_api_key]="tinyMceApiKey"
                    [tiny_mce_init]="tinyMceInit"
                  />
                }
                @case ('attachments') {
                  <app-meeting-record-attachments-tab
                    [attachments]="attachments()"
                    [can_manage]="can_manage_attachments()"
                    [is_create]="is_create"
                    (download_attachment)="downloadMeetingRecordAttachment($event)"
                    (delete_attachment)="deleteMeetingRecordAttachment($event)"
                  />
                }
              }
            </section>
          </div>
        </div>

        <aside class="meeting-record-sidebar">
          <section class="card card-block meeting-record-date-card meeting-record-date-in-sidebar">
            <div class="card-header-simple">
              <h2>Fecha de reunión</h2>
            </div>
            <mat-form-field appearance="outline" class="nobottom meeting-record-date-field">
              <mat-label>Fecha de reunión</mat-label>
              <input matInput [matDatepicker]="sidebar_date_picker" formControlName="date" />
              <mat-datepicker-toggle matSuffix [for]="sidebar_date_picker"></mat-datepicker-toggle>
              <mat-datepicker #sidebar_date_picker></mat-datepicker>
            </mat-form-field>
          </section>

          <section class="card card-block">
            <div class="card-header-simple">
              <h2>Contexto reunión</h2>
            </div>

            @if (is_create && meetingableType === 'App\\Models\\JobVacancyCandidatePhaseProgress') {
              <mat-form-field appearance="outline" class="nobottom context-select-field">
                <mat-label>Fase de proceso</mat-label>
                <mat-select formControlName="meetingable_id">
                  @for (phase_progress of candidate_phase_progress_options; track phase_progress.id) {
                    <mat-option [value]="phase_progress.id">
                      {{ phase_progress.job_vacancy_phase?.name ?? 'Fase #' + phase_progress.job_vacancy_phase_id }}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>

              <div class="context-metadata">
                <p><strong>Entrevistado:</strong> {{ interviewed_user_label }}</p>
                <p><strong>Fase:</strong> {{ selected_candidate_phase_label }}</p>
              </div>
            } @else {
              @if (meetingableType === 'App\\Models\\JobVacancyCandidatePhaseProgress') {
                <div class="context-metadata">
                  <p><strong>Entrevistado:</strong> {{ interviewed_user_label }}</p>
                  <p><strong>Fase:</strong> {{ selected_candidate_phase_label }}</p>
                </div>
              } @else if (meetingableType === 'App\\Models\\User') {
                <div class="context-metadata">
                  <p><strong>Reunión sobre empleado</strong></p>
                  <p>{{ meetingable_label }}</p>
                </div>
              } @else if (meetingableType === 'App\\Models\\PotentialClient') {
                <div class="context-metadata">
                  <p><strong>Potencial cliente</strong></p>
                  <p>{{ meetingable_label }}</p>
                </div>
              } @else {
                <p class="card-description">{{ meetingable_card_description }}</p>
              }
            }
          </section>

          @if (can_have_exam) {
            <section class="card card-block">
              <div class="card-header-simple">
                <h2>Examen</h2>
                <div class="card-actions">
                  @if (can_manage_exams && !has_linked_exam_evaluation) {
                    <button mat-stroked-button type="button" (click)="open_exam_template_selector_for_creation()">
                      Iniciar evaluación
                    </button>
                  }
                  @if (has_linked_exam_evaluation) {
                    <button mat-stroked-button color="accent" type="button" (click)="open_exam_instance_evaluation_detail()">
                      Ver examen
                    </button>
                  }
                </div>
              </div>

              @if (can_manage_exams && has_linked_exam_evaluation && selected_exam_instance_evaluation) {
                <div class="exam-metadata">
                  <p><strong>Estado:</strong> {{ exam_state_label }}</p>
                  <p><strong>Nota:</strong> {{ selected_exam_instance_evaluation.score_over_ten ?? '—' }}</p>
                </div>
              }
            </section>
          }

          <section
            class="card card-block recording-card"
            matTooltip="Crea el acta para poder grabar la reunión"
            [matTooltipDisabled]="!is_create"
          >
            <div class="card-header-simple">
              <h2>Grabación</h2>
              @if (meetingRecordId && media_recordings().length > 0) {
                <div class="recordings-list-trigger">
                  <button
                    mat-icon-button
                    type="button"
                    class="small-icon-button"
                    matTooltip="Ver grabaciones"
                    aria-label="Ver grabaciones"
                    (click)="openMediaRecordingsDialog()"
                  >
                    <mat-icon>visibility</mat-icon>
                  </button>
                  <span class="recordings-count-badge">{{ media_recordings().length }}</span>
                </div>
              }
            </div>

            @let recording_card = recording_card_view();

            @if (recording_card.show_live_panel && recording_card.active_recording) {
              @let active_recording = recording_card.active_recording;
              @let is_stopping_recording = active_recording.status === 'stopping';
              <div class="recording-live-panel">
                <div class="recording-live-indicators">
                  @if (active_recording.include_microphone) {
                    <mat-icon class="recording-indicator-icon recording-indicator-static" matTooltip="Micrófono activo">mic</mat-icon>
                  }
                  @if (active_recording.include_screen) {
                    <mat-icon class="recording-indicator-icon recording-indicator-static" matTooltip="Pantalla activa"
                      >screen_share</mat-icon
                    >
                  }
                  @if (active_recording.include_system_audio) {
                    <mat-icon class="recording-indicator-icon recording-indicator-static" matTooltip="Audio del sistema activo"
                      >volume_up</mat-icon
                    >
                  }
                  <span class="recording-live-duration">{{ active_recording.elapsed_seconds | recordingElapsedLabel }}</span>
                  @if (is_stopping_recording) {
                    <span class="recording-live-status">Deteniendo…</span>
                  } @else if (active_recording.status === 'paused') {
                    <span class="recording-live-status">Pausada</span>
                  }
                </div>
                <div class="recording-live-actions">
                  @if (active_recording.status === 'recording') {
                    <button
                      mat-icon-button
                      type="button"
                      [disabled]="is_stopping_recording"
                      (click)="pauseRecording()"
                      matTooltip="Pausar"
                      aria-label="Pausar grabación"
                    >
                      <mat-icon>pause</mat-icon>
                    </button>
                  } @else if (!is_stopping_recording) {
                    <button mat-icon-button type="button" (click)="resumeRecording()" matTooltip="Reanudar" aria-label="Reanudar grabación">
                      <mat-icon>play_arrow</mat-icon>
                    </button>
                  }
                  <button
                    mat-icon-button
                    type="button"
                    color="warn"
                    [disabled]="is_stopping_recording"
                    (click)="stopRecording()"
                    [matTooltip]="is_stopping_recording ? 'Deteniendo grabación…' : 'Parar grabación'"
                    [attr.aria-label]="is_stopping_recording ? 'Deteniendo grabación' : 'Parar grabación'"
                  >
                    <mat-icon>{{ is_stopping_recording ? 'hourglass_top' : 'stop' }}</mat-icon>
                  </button>
                  <button
                    mat-icon-button
                    type="button"
                    [disabled]="is_stopping_recording"
                    (click)="discardRecording()"
                    matTooltip="Descartar grabación"
                    aria-label="Descartar grabación"
                  >
                    <mat-icon>delete</mat-icon>
                  </button>
                </div>
              </div>
            } @else if (recording_card.show_upload_panel && recording_card.active_recording) {
              @let active_recording = recording_card.active_recording;
              <div class="recording-banner recording-banner-pending">
                <p>
                  <strong>{{ active_recording.status | mediaRecordingStatusLabel }}</strong> — {{ active_recording.concept }}
                </p>
                @if (active_recording.upload_status_label) {
                  <p class="card-description">{{ active_recording.upload_status_label }}</p>
                }
                @if (active_recording.upload_progress_mode === 'indeterminate' || active_recording.status === 'processing') {
                  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
                } @else if (active_recording.upload_progress_percent > 0) {
                  <mat-progress-bar mode="determinate" [value]="active_recording.upload_progress_percent"></mat-progress-bar>
                }
                @if (active_recording.error_message) {
                  <p class="recording-error-text">{{ active_recording.error_message }}</p>
                }
                @if (active_recording.upload_retry_summary) {
                  <p class="card-description">{{ active_recording.upload_retry_summary }}</p>
                }
                @if (
                  active_recording.status === 'upload_failed' ||
                  active_recording.status === 'pending_upload' ||
                  active_recording.status === 'failed'
                ) {
                  <button mat-stroked-button type="button" (click)="retryRecordingUpload(active_recording.client_local_id)">
                    {{ active_recording.upload_retry_button_label ?? 'Reintentar ahora' }}
                  </button>
                  <button mat-stroked-button type="button" (click)="discardFailedRecordingUpload(active_recording.client_local_id)">
                    Descartar
                  </button>
                }
              </div>
            } @else if (recording_card.show_blocked_panel) {
              <div class="recording-blocked-panel">
                <mat-icon class="recording-blocked-icon">info</mat-icon>
                <div class="recording-blocked-content">
                  <p class="recording-blocked-message">{{ recording_card.block_message }}</p>
                  @if (recording_card.active_recording) {
                    @let active_recording = recording_card.active_recording;
                    <p class="card-description">
                      {{ active_recording.concept }}
                      · {{ active_recording.status | mediaRecordingStatusLabel }} ·
                      {{ active_recording.elapsed_seconds | recordingElapsedLabel }}
                    </p>
                  }
                </div>
              </div>
            } @else if (recording_card.show_deadline_blocked_panel) {
              <div class="recording-blocked-panel">
                <mat-icon class="recording-blocked-icon">info</mat-icon>
                <div class="recording-blocked-content">
                  <p class="recording-blocked-message">{{ meeting_recording_deadline_panel_message() }}</p>
                </div>
              </div>
            } @else if (recording_card.show_idle_panel) {
              <div class="recording-idle-panel">
                @if (is_recording_available) {
                  <button
                    mat-flat-button
                    type="button"
                    class="recording-rec-button"
                    [disabled]="!can_add_meeting_recording()"
                    (click)="openRecordingSetupDialog()"
                  >
                    <mat-icon>fiber_manual_record</mat-icon>
                    REC
                  </button>
                }
                @if (meetingRecordId && can_add_meeting_recording()) {
                  <button
                    mat-icon-button
                    type="button"
                    class="recording-import-menu-button"
                    [disabled]="is_importing_media_recording"
                    [matMenuTriggerFor]="recording_import_menu"
                    matTooltip="Importar grabación"
                    aria-label="Importar grabación"
                  >
                    <mat-icon>more_vert</mat-icon>
                  </button>
                  <mat-menu #recording_import_menu="matMenu">
                    <button mat-menu-item type="button" (click)="openImportAudioFilePicker()">
                      <mat-icon>upload_file</mat-icon>
                      <span>Importar desde audio</span>
                    </button>
                    <button mat-menu-item type="button" (click)="openImportYoutubeDialog()">
                      <mat-icon>link</mat-icon>
                      <span>Importar desde YouTube</span>
                    </button>
                  </mat-menu>
                }
              </div>
            }

            @for (processing_recording of processing_media_recordings(); track processing_recording.id) {
              @if (!recording_card.active_recording || recording_card.active_recording.server_id !== processing_recording.id) {
                <div class="recording-banner recording-banner-pending">
                  <p>
                    <strong>{{ processing_recording | mediaRecordingStatusLabel }}</strong> — {{ processing_recording.concept }}
                  </p>
                  <p class="card-description">{{ processing_recording | mediaRecordingServerProcessingLabel }}</p>
                  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
                </div>
              }
            }

            @for (transcription_recording of transcription_in_flight_media_recordings(); track transcription_recording.id) {
              <div class="recording-banner recording-banner-pending">
                <p>
                  <strong>{{ transcription_recording | mediaRecordingTranscriptionBannerLabel }}</strong> —
                  {{ transcription_recording.concept }}
                </p>
                <mat-progress-bar mode="indeterminate"></mat-progress-bar>
              </div>
            }

            @if (summary_generation_status() === 'processing') {
              <div class="recording-banner recording-banner-pending">
                <p><strong>Generando resumen con IA…</strong></p>
                <p class="card-description">El resumen aparecerá en la pestaña Resumen cuando esté listo.</p>
                <mat-progress-bar mode="indeterminate"></mat-progress-bar>
              </div>
            }

            @for (pending of visible_meeting_record_pending_uploads(); track pending.client_local_id) {
              <div class="recording-banner recording-banner-pending">
                <p><strong>Grabación pendiente de subir</strong> — {{ pending.concept }}</p>
                <p class="card-description">
                  {{ pending.pending_chunk_indexes.length }} chunks pendientes
                  @if (pending.duration_seconds) {
                    · {{ pending.duration_seconds | recordingElapsedLabel }}
                  }
                </p>
                <button mat-stroked-button type="button" (click)="retryRecordingUpload(pending.client_local_id)">Reintentar ahora</button>
                <button mat-stroked-button type="button" (click)="discardFailedRecordingUpload(pending.client_local_id)">Descartar</button>
              </div>
            }
          </section>
        </aside>
      </div>
    </div>
  </ngx-dropzone>
</div>
